const translatePaymentDetailsValue = (t, { value, translate }) => {
  return translate
    ? value && t(`FORM_FIELDS:ENUM_${value.toUpperCase().replace(/\W/g, '_')}`, value)
    : value || '';
};

export default translatePaymentDetailsValue;
